import { Kalenderhändelse } from '../../types/pages';

export type YearMap = Map<number, MonthMap[]>;
export type MonthMap = Map<number, Kalenderhändelse[]>;

export function konverteraKalenderHändelserTillYearMap(kalenderHändelser: Kalenderhändelse[]): YearMap {
  const yearMap = new Map<number, MonthMap[]>();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  kalenderHändelser.forEach((händelse) => {
    const händelsedatum = new Date(händelse.händelsedatum);
    händelsedatum.setHours(0, 0, 0, 0);

    const år = händelsedatum.getFullYear();
    const månad = händelsedatum.getMonth() + 1;

    if (!yearMap.has(år)) {
      yearMap.set(år, []);
    }

    const monthMapArray = yearMap.get(år)!;
    let monthMap = monthMapArray.find(map => map.has(månad));

    if (!monthMap) {
      monthMap = new Map<number, Kalenderhändelse[]>();
      monthMapArray.push(monthMap);
    }

    if (!monthMap.has(månad)) {
      monthMap.set(månad, []);
    }

    monthMap.get(månad)!.push(händelse);
  });

  return yearMap;
}
